import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import PersonalCustomerService from "services/Setup/Organization/personalCustomerService";
import { notification } from "antd";

export const initialState = {
  message: "",
  loading: false,
  loadingIdentityList: false,
  loadingJobList: false,
  loadingFinancialList: false,
  loadingSpouseList: false,
  loadingEmergencyList: false,
  loadingFamilyList: false,
  loadingLoanList: false,

  IsIdentityPosted: false,
  resultPostIdentity: {},

  IsJobPosted: false,
  resultPostJob: {},

  IsFinancialPosted: false,
  resultPostFinancial: {},

  IsSpousePosted: false,
  resultPostSpouse: {},

  IsEmergencyPosted: false,
  resultPostEmergency: {},

  IsFamilyPosted: false,
  resultPostFamily: {},

  IsLoanPosted: false,
  resultPostLoan: {},

  IsIdentityUpdated: false,
  resultUpdateIdentity: {},

  IsJobUpdated: false,
  resultUpdateJob: {},

  IsFinancialUpdated: false,
  resultUpdateFinancial: {},

  IsSpouseUpdated: false,
  resultUpdateSpouse: {},

  IsEmergencyUpdated: false,
  resultUpdateEmergency: {},

  IsFamilyUpdated: false,
  resultUpdateFamily: {},

  IsLoanUpdated: false,
  resultUpdateLoan: {},

  CIFNO: "",

  responseStatusIdnty: null,
  responseStatusOcptn: null,
  responseStatusFinancial: null,
  responseStatusSpse: null,
  responseStatusEmrgncy: null,
  responseStatusFamily: null,
  responseStatusLoan: null,
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  PersonalCustomerList: {},
  ProspectCustomerList: {},
  ProspectCustomerByIdList: {},
  PersonalCustomerJobList: {},
  PersonalCustomerFinancialList: {},
  PersonalCustomerSpouseList: {},
  PersonalCustomerEmergencyList: {},
  PersonalCustomerFamilyList: {},
  PersonalCustomerLoanList: {},
  CalculateWorkPeriod: {},
  loadingCalculateWorkPeriod: false,
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
};

export const getProspectCustomerList = createAsyncThunk(
  "personalCustomer/getProspectCustomerList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await PersonalCustomerService.getProspectCustomerList(
        userInput
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getProspectCustomerByIdList = createAsyncThunk(
  "personalCustomer/getProspectCustomerByIdList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await PersonalCustomerService.getProspectCustomerByIdList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getPersonalCustomerList = createAsyncThunk(
  "personalCustomer/getPersonalCustomerList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await PersonalCustomerService.getPersonalCustomerList(
        userInput
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getPersonalCustomerJobList = createAsyncThunk(
  "personalCustomer/getPersonalCustomerJobList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await PersonalCustomerService.getPersonalCustomerJobList(
        userInput
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getPersonalCustomerFinancialList = createAsyncThunk(
  "personalCustomer/getPersonalCustomerFinancialList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await PersonalCustomerService.getPersonalCustomerFinancialList(
          userInput
        );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getPersonalCustomerSpouseList = createAsyncThunk(
  "personalCustomer/getPersonalCustomerSpouseList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await PersonalCustomerService.getPersonalCustomerSpouseList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getPersonalCustomerEmergencyList = createAsyncThunk(
  "personalCustomer/getPersonalCustomerEmergencyList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await PersonalCustomerService.getPersonalCustomerEmergencyList(
          userInput
        );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getPersonalCustomerFamilyList = createAsyncThunk(
  "personalCustomer/getPersonalCustomerFamilyList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await PersonalCustomerService.getPersonalCustomerFamilyList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getPersonalCustomerLoanList = createAsyncThunk(
  "personalCustomer/getPersonalCustomerLoanList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await PersonalCustomerService.getPersonalCustomerLoanList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCalculateWorkPeriod = createAsyncThunk(
  "personalCustomer/getCalculateWorkPeriod",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await PersonalCustomerService.getCalculateWorkPeriod(
        userInput
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postPersonalCustomer = createAsyncThunk(
  "personalCustomer/postPersonalCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PersonalCustomerService.postPersonalCustomer(data);
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postPersonalCustomerJob = createAsyncThunk(
  "personalCustomer/postPersonalCustomerJob",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PersonalCustomerService.postPersonalCustomerJob(
        data
      );
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postPersonalCustomerFinancial = createAsyncThunk(
  "personalCustomer/postPersonalCustomerFinancial",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PersonalCustomerService.postPersonalCustomerFinancial(data);
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postPersonalCustomerSpouse = createAsyncThunk(
  "personalCustomer/postPersonalCustomerSpouse",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PersonalCustomerService.postPersonalCustomerSpouse(
        data
      );
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postPersonalCustomerEmergency = createAsyncThunk(
  "personalCustomer/postPersonalCustomerEmergency",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PersonalCustomerService.postPersonalCustomerEmergency(data);
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postPersonalCustomerFamily = createAsyncThunk(
  "personalCustomer/postPersonalCustomerFamily",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PersonalCustomerService.postPersonalCustomerFamily(
        data
      );
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postPersonalCustomerLoan = createAsyncThunk(
  "personalCustomer/postPersonalCustomerLoan",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PersonalCustomerService.postPersonalCustomerLoan(
        data
      );
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updatePersonalCustomer = createAsyncThunk(
  "personalCustomer/updatePersonalCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PersonalCustomerService.updatePersonalCustomer(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updatePersonalCustomerJob = createAsyncThunk(
  "personalCustomer/updatePersonalCustomerJob",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PersonalCustomerService.updatePersonalCustomerJob(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updatePersonalCustomerFinancial = createAsyncThunk(
  "personalCustomer/updatePersonalCustomerFinancial",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PersonalCustomerService.updatePersonalCustomerFinancial(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updatePersonalCustomerSpouse = createAsyncThunk(
  "personalCustomer/updatePersonalCustomerSpouse",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PersonalCustomerService.updatePersonalCustomerSpouse(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updatePersonalCustomerEmergency = createAsyncThunk(
  "personalCustomer/updatePersonalCustomerEmergency",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PersonalCustomerService.updatePersonalCustomerEmergency(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updatePersonalCustomerFamily = createAsyncThunk(
  "personalCustomer/updatePersonalCustomerFamily",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PersonalCustomerService.updatePersonalCustomerFamily(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updatePersonalCustomerLoan = createAsyncThunk(
  "personalCustomer/updatePersonalCustomerLoan",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PersonalCustomerService.updatePersonalCustomerLoan(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deletePersonalCustomer = createAsyncThunk(
  "personalCustomer/deletePersonalCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PersonalCustomerService.deletePersonalCustomer(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deletePersonalCustomerFamily = createAsyncThunk(
  "personalCustomer/deletePersonalCustomerFamily",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await PersonalCustomerService.deletePersonalCustomerFamily(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deletePersonalCustomerLoan = createAsyncThunk(
  "personalCustomer/deletePersonalCustomerLoan",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PersonalCustomerService.deletePersonalCustomerLoan(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) { 
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const PersonalCustomerSlice = createSlice({
  name: "personalCustomer",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    resetDataCustomer: (state) => {
      state.PersonalCustomerList = {};
      state.PersonalCustomerJobList = {};
      state.PersonalCustomerFinancialList = {};
      state.PersonalCustomerSpouseList = {};
      state.PersonalCustomerEmergencyList = {};
      state.PersonalCustomerFamilyList = {};
      state.PersonalCustomerFamilyList = {};
      state.PersonalCustomerLoanList = {};
    },
    resetStatePersonalCustomer: () => initialState,
  },

  extraReducers: (builder) => {
    builder

      //list prospect customer
      .addCase(getProspectCustomerList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getProspectCustomerList.fulfilled, (state, action) => {
        state.loading = false;
        state.ProspectCustomerList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getProspectCustomerList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list prospect customer by id
      .addCase(getProspectCustomerByIdList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getProspectCustomerByIdList.fulfilled, (state, action) => {
        state.loading = false;
        state.ProspectCustomerByIdList = action.payload;
        // state.getCount = action.payload.count;
      })
      .addCase(getProspectCustomerByIdList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list personal customer
      .addCase(getPersonalCustomerList.pending, (state) => {
        state.loadingIdentityList = true;
        state.redirect = "";
      })
      .addCase(getPersonalCustomerList.fulfilled, (state, action) => {
        state.loadingIdentityList = false;
        state.PersonalCustomerList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getPersonalCustomerList.rejected, (state, action) => {
        state.loadingIdentityList = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list personal customer job
      .addCase(getPersonalCustomerJobList.pending, (state) => {
        state.loadingJobList = true;
        state.redirect = "";
      })
      .addCase(getPersonalCustomerJobList.fulfilled, (state, action) => {
        state.loadingJobList = false;
        state.PersonalCustomerJobList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getPersonalCustomerJobList.rejected, (state, action) => {
        state.loadingJobList = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list personal customer finance
      .addCase(getPersonalCustomerFinancialList.pending, (state) => {
        state.loadingFinancialList = true;
        state.redirect = "";
      })
      .addCase(getPersonalCustomerFinancialList.fulfilled, (state, action) => {
      
        
        state.loadingFinancialList = false;
        state.PersonalCustomerFinancialList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getPersonalCustomerFinancialList.rejected, (state, action) => {
        state.loadingFinancialList = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list personal customer spouse
      .addCase(getPersonalCustomerSpouseList.pending, (state) => {
        state.loadingSpouseList = true;
        state.redirect = "";
      })
      .addCase(getPersonalCustomerSpouseList.fulfilled, (state, action) => {
        state.loadingSpouseList = false;
        state.PersonalCustomerSpouseList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getPersonalCustomerSpouseList.rejected, (state, action) => {
        state.loadingSpouseList = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list personal customer emergency
      .addCase(getPersonalCustomerEmergencyList.pending, (state) => {
        state.loadingEmergencyList = true;
        state.redirect = "";
      })
      .addCase(getPersonalCustomerEmergencyList.fulfilled, (state, action) => {
        state.loadingEmergencyList = false;
        state.PersonalCustomerEmergencyList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getPersonalCustomerEmergencyList.rejected, (state, action) => {
        state.loadingEmergencyList = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list personal customer (family)
      .addCase(getPersonalCustomerFamilyList.pending, (state) => {
        state.loadingFamilyList = true;
        state.redirect = "";
      })
      .addCase(getPersonalCustomerFamilyList.fulfilled, (state, action) => {
        state.loadingFamilyList = false;
        state.PersonalCustomerFamilyList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getPersonalCustomerFamilyList.rejected, (state, action) => {
        state.loadingFamilyList = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list personal customer (loan)
      .addCase(getPersonalCustomerLoanList.pending, (state) => {
        state.loadingLoanList = true;
        state.redirect = "";
      })
      .addCase(getPersonalCustomerLoanList.fulfilled, (state, action) => {
        state.loadingLoanList = false;
        state.PersonalCustomerLoanList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getPersonalCustomerLoanList.rejected, (state, action) => {
        state.loadingLoanList = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list Work period
      .addCase(getCalculateWorkPeriod.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCalculateWorkPeriod.fulfilled, (state, action) => {
        state.loading = false;
        state.CalculateWorkPeriod = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getCalculateWorkPeriod.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //post personal customer
      .addCase(postPersonalCustomer.pending, (state) => {
        state.loading = true;
        state.responseStatusIdnty = 201;
        state.IsIdentityPosted = false;
      })
      .addCase(postPersonalCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
        state.responseStatusIdnty = action.payload.status;
        state.resultPostIdentity = action.payload.data.status;
        state.IsIdentityPosted = true;
        state.CIFNO = action.payload.data.message;
      })
      .addCase(postPersonalCustomer.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.IsIdentityPosted = false;
      })

      //post PersonalCustomerJob
      .addCase(postPersonalCustomerJob.pending, (state) => {
        state.loading = true;
        state.IsJobPosted = false;
      })
      .addCase(postPersonalCustomerJob.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
        state.responseStatusOcptn = action.payload.status;
        state.resultPostJob = action.payload.data.status;
        state.IsJobPosted = true;
      })
      .addCase(postPersonalCustomerJob.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.IsJobPosted = false;
      })

      //post PersonalCustomerFinancial
      .addCase(postPersonalCustomerFinancial.pending, (state) => {
        state.loading = true;
        state.responseStatusFinancial = 201;
        state.IsFinancialPosted = false;
      })
      .addCase(postPersonalCustomerFinancial.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
        state.responseStatusFinancial = action.payload.status;
        state.resultPostFinancial = action.payload.data.status;
        state.IsFinancialPosted = true;
      })
      .addCase(postPersonalCustomerFinancial.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.IsFinancialPosted = false;
      })

      //post PersonalCustomerSpouse
      .addCase(postPersonalCustomerSpouse.pending, (state) => {
        state.loading = true;
        state.responseStatusSpse = 201;
        state.IsSpousePosted = false;
      })
      .addCase(postPersonalCustomerSpouse.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
        state.responseStatusSpse = action.payload.status;
        state.resultPostSpouse = action.payload.data.status;
        state.IsSpousePosted = true;
      })
      .addCase(postPersonalCustomerSpouse.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.IsSpousePosted = false;
      })

      //post PersonalCustomerEmergency
      .addCase(postPersonalCustomerEmergency.pending, (state) => {
        state.loading = true;
        state.responseStatusEmrgncy = 201;
        state.IsEmergencyPosted = false;
      })
      .addCase(postPersonalCustomerEmergency.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
        state.responseStatusEmrgncy = action.payload.status;
        state.resultPostEmergency = action.payload.data.status;
        state.IsEmergencyPosted = true;
      })
      .addCase(postPersonalCustomerEmergency.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.IsEmergencyPosted = false;
      })

      //post PersonalCustomerFamily
      .addCase(postPersonalCustomerFamily.pending, (state) => {
        state.loading = true;
        state.responseStatusFamily = 201;
        state.IsFamilyPosted = false;
      })
      .addCase(postPersonalCustomerFamily.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
        state.responseStatusFamily = action.payload.status;
        state.resultPostFamily = action.payload.data.status;
        state.IsFamilyPosted = true;
      })
      .addCase(postPersonalCustomerFamily.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.IsFamilyPosted = false;
      })

      //post PersonalCustomerLoan
      .addCase(postPersonalCustomerLoan.pending, (state) => {
        state.loading = true;
        state.responseStatusLoan = 201;
        state.IsLoanPosted = false;
      })
      .addCase(postPersonalCustomerLoan.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
        state.responseStatusLoan = action.payload.status;
        state.resultPostLoan = action.payload.data.status;
        state.IsLoanPosted = true;
      })
      .addCase(postPersonalCustomerLoan.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.IsLoanPosted = false;
      })

      //update personal customer
      .addCase(updatePersonalCustomer.pending, (state) => {
        state.loading = true;
        state.responseStatusIdnty = 201;
        state.IsIdentityUpdated = false;
      })
      .addCase(updatePersonalCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.responseStatusIdnty = action.payload.status;
        state.IsIdentityUpdated = true;
        state.resultUpdateIdentity = action.payload.data.status;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updatePersonalCustomer.rejected, (state, action) => {
        state.loading = false;
        state.IsIdentityUpdated = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //update personal customer job
      .addCase(updatePersonalCustomerJob.pending, (state) => {
        state.loading = true;
        state.responseStatusOcptn = 201;
        state.IsJobUpdated = false;
      })
      .addCase(updatePersonalCustomerJob.fulfilled, (state, action) => {
        state.loading = false;
        state.responseStatusOcptn = action.payload.status;
        state.IsJobUpdated = true;
        state.resultUpdateJob = action.payload.data.status;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updatePersonalCustomerJob.rejected, (state, action) => {
        state.loading = false;
        state.IsJobUpdated = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //update personal customer financial
      .addCase(updatePersonalCustomerFinancial.pending, (state) => {
        state.loading = true;
        state.responseStatusFinancial = 201;
        state.IsFinancialUpdated = false;
      })
      .addCase(updatePersonalCustomerFinancial.fulfilled, (state, action) => {
        state.loading = false;
        state.responseStatusFinancial = action.payload.status;
        state.IsFinancialUpdated = true;
        state.resultUpdateFinancial = action.payload.data.status;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updatePersonalCustomerFinancial.rejected, (state, action) => {
        state.loading = false;
        state.IsFinancialUpdated = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //update personal customer spouse
      .addCase(updatePersonalCustomerSpouse.pending, (state) => {
        state.loading = true;
        state.responseStatusSpse = 201;
        state.IsSpouseUpdated = false;
      })
      .addCase(updatePersonalCustomerSpouse.fulfilled, (state, action) => {
        state.loading = false;
        state.responseStatusSpse = action.payload.status;
        state.IsSpouseUpdated = true;
        state.resultUpdateSpouse = action.payload.data.status;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updatePersonalCustomerSpouse.rejected, (state, action) => {
        state.loading = false;
        state.IsSpouseUpdated = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //update personal customer emergency
      .addCase(updatePersonalCustomerEmergency.pending, (state) => {
        state.loading = true;
        state.responseStatusEmrgncy = 201;
        state.IsEmergencyUpdated = false;
      })
      .addCase(updatePersonalCustomerEmergency.fulfilled, (state, action) => {
        state.loading = false;
        state.responseStatusEmrgncy = action.payload.status;
        state.IsEmergencyUpdated = true;
        state.resultUpdateEmergency = action.payload.data.status;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updatePersonalCustomerEmergency.rejected, (state, action) => {
        state.loading = false;
        state.IsEmergencyUpdated = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //update personal customer (family)
      .addCase(updatePersonalCustomerFamily.pending, (state) => {
        state.loading = true;
        state.responseStatusFamily = 201;
        state.IsFamilyUpdated = false;
      })
      .addCase(updatePersonalCustomerFamily.fulfilled, (state, action) => {
        state.loading = false;
        state.responseStatusFamily = action.payload.status;
        state.IsFamilyUpdated = true;
        state.resultUpdateFamily = action.payload.data.status;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updatePersonalCustomerFamily.rejected, (state, action) => {
        state.loading = false;
        state.IsFamilyUpdated = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //update personal customer (loan)
      .addCase(updatePersonalCustomerLoan.pending, (state) => {
        state.loading = true;
        state.responseStatusLoan = 201;
        state.IsLoanUpdated = false;
      })
      .addCase(updatePersonalCustomerLoan.fulfilled, (state, action) => {
        state.loading = false;
        state.responseStatusLoan = action.payload.status;
        state.IsLoanUpdated = true;
        state.resultUpdateLoan = action.payload.data.status;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updatePersonalCustomerLoan.rejected, (state, action) => {
        state.loading = false;
        state.IsLoanUpdated = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //delete personal customer
      .addCase(deletePersonalCustomer.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePersonalCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deletePersonalCustomer.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //delete personal customer (family)
      .addCase(deletePersonalCustomerFamily.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePersonalCustomerFamily.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deletePersonalCustomerFamily.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //delete personal customer (loan)
      .addCase(deletePersonalCustomerLoan.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePersonalCustomerLoan.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deletePersonalCustomerLoan.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  resetStatePersonalCustomer,
  showNotification,
  hideNotification,
  showLoading,
  resetDataCustomer,
} = PersonalCustomerSlice.actions;

export default PersonalCustomerSlice.reducer;
